import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { FreeStampList } from 'shell/models/timber';
import { memo } from 'react';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface TimberFreeSelectProps {
  value?: string;
  onChange: (item: string, totalItem?: FreeStampItem) => void;
  error?: boolean;
  actType?: string;
}

export type FreeStampItem = ItemVM & { itemField: FreeStampList };

const TimberFreeSelectComponent = ({
  value,
  onChange,
  error,
  actType,
}: TimberFreeSelectProps): React.ReactElement => {
  const [listaTimbriFisso] = useHttpFetch<HttpResponseList<FreeStampList>, Array<FreeStampItem>>(
    `${__CIVIL_STATUS_API_URL__}/testo-stampa-certificazione/lista-timbri-stampa-certificazione/TUTTE-TIMBROLIBERO-${actType}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response: AxiosResponse<HttpResponseList<FreeStampList>>) => {
        const { data } = response;
        return data?.payload.list?.map((item) => ({
          id: item.key?.codiceTesto || '',
          value: item.testoStampa || '',
          itemField: item,
        }));
      },
    }
  );

  const freeStampsList = (listaTimbriFisso.data as Array<FreeStampItem>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id={`id-select-timberFreeText`}>
        Timbro Testo Libero
      </InputLabel>
      <PmiSelect
        error={error}
        labelId={`label-select-timberFreeText`}
        id={`id-select-timberFreeText`}
        name={`id-select-timberFreeText`}
        value={value}
        label={'Timbro Testo Libero'}
        onChange={(event) =>
          onChange(
            event?.target.value,
            freeStampsList.find((item) => item.id === event.target.value)
          )
        }
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {freeStampsList.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TimberFreeSelectComponent.displayName = 'Timber Free Select';

const TimberFreeSelect = memo(TimberFreeSelectComponent);

export default TimberFreeSelect;
